import { createContext } from 'react';
import { TLanguageIDs, IModifierPortionForGetInfo } from 'types';

export interface IViewPortionState {
	portionFullInfo: Nullable<IModifierPortionForGetInfo>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
}

export const viewPortionInitialState: IViewPortionState = {
	portionFullInfo: null,
	selectedTranslationTab: null,
};

export interface IViewPortionContext extends IViewPortionState {
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
}

export const ViewPortionContext = createContext<IViewPortionContext>({
	setTranslationTab: () => undefined,
	...viewPortionInitialState,
});
